export const countryPhoneCodeDictionary = [
  {
    countryCode: 'AD',
    phoneCode: 376,
  },
  {
    countryCode: 'AE',
    phoneCode: 971,
  },
  {
    countryCode: 'AF',
    phoneCode: 93,
  },
  {
    countryCode: 'AG',
    phoneCode: 1,
  },
  {
    countryCode: 'AI',
    phoneCode: 1,
  },
  {
    countryCode: 'AL',
    phoneCode: 355,
  },
  {
    countryCode: 'AM',
    phoneCode: 374,
  },
  {
    countryCode: 'AO',
    phoneCode: 244,
  },
  {
    countryCode: 'AR',
    phoneCode: 54,
  },
  {
    countryCode: 'AS',
    phoneCode: 1,
  },
  {
    countryCode: 'AT',
    phoneCode: 43,
  },
  {
    countryCode: 'AU',
    phoneCode: 61,
  },
  {
    countryCode: 'AW',
    phoneCode: 297,
  },
  {
    countryCode: 'AX',
    phoneCode: 358,
  },
  {
    countryCode: 'AZ',
    phoneCode: 994,
  },
  {
    countryCode: 'BA',
    phoneCode: 387,
  },
  {
    countryCode: 'BB',
    phoneCode: 1,
  },
  {
    countryCode: 'BD',
    phoneCode: 880,
  },
  {
    countryCode: 'BE',
    phoneCode: 32,
  },
  {
    countryCode: 'BF',
    phoneCode: 226,
  },
  {
    countryCode: 'BG',
    phoneCode: 359,
  },
  {
    countryCode: 'BH',
    phoneCode: 973,
  },
  {
    countryCode: 'BI',
    phoneCode: 257,
  },
  {
    countryCode: 'BJ',
    phoneCode: 229,
  },
  {
    countryCode: 'BL',
    phoneCode: 590,
  },
  {
    countryCode: 'BM',
    phoneCode: 1,
  },
  {
    countryCode: 'BN',
    phoneCode: 673,
  },
  {
    countryCode: 'BO',
    phoneCode: 591,
  },
  {
    countryCode: 'BQ',
    phoneCode: 599,
  },
  {
    countryCode: 'BR',
    phoneCode: 55,
  },
  {
    countryCode: 'BS',
    phoneCode: 1,
  },
  {
    countryCode: 'BT',
    phoneCode: 975,
  },
  {
    countryCode: 'BW',
    phoneCode: 267,
  },
  {
    countryCode: 'BY',
    phoneCode: 375,
  },
  {
    countryCode: 'BZ',
    phoneCode: 501,
  },
  {
    countryCode: 'CA',
    phoneCode: 1,
  },
  {
    countryCode: 'CC',
    phoneCode: 61,
  },
  {
    countryCode: 'CD',
    phoneCode: 243,
  },
  {
    countryCode: 'CF',
    phoneCode: 236,
  },
  {
    countryCode: 'CG',
    phoneCode: 242,
  },
  {
    countryCode: 'CH',
    phoneCode: 41,
  },
  {
    countryCode: 'CI',
    phoneCode: 225,
  },
  {
    countryCode: 'CK',
    phoneCode: 682,
  },
  {
    countryCode: 'CL',
    phoneCode: 56,
  },
  {
    countryCode: 'CM',
    phoneCode: 237,
  },
  {
    countryCode: 'CN',
    phoneCode: 86,
  },
  {
    countryCode: 'CO',
    phoneCode: 57,
  },
  {
    countryCode: 'CR',
    phoneCode: 506,
  },
  {
    countryCode: 'CU',
    phoneCode: 53,
  },
  {
    countryCode: 'CV',
    phoneCode: 238,
  },
  {
    countryCode: 'CW',
    phoneCode: 599,
  },
  {
    countryCode: 'CX',
    phoneCode: 61,
  },
  {
    countryCode: 'CY',
    phoneCode: 357,
  },
  {
    countryCode: 'CZ',
    phoneCode: 420,
  },
  {
    countryCode: 'DE',
    phoneCode: 49,
  },
  {
    countryCode: 'DJ',
    phoneCode: 253,
  },
  {
    countryCode: 'DK',
    phoneCode: 45,
  },
  {
    countryCode: 'DM',
    phoneCode: 1,
  },
  {
    countryCode: 'DO',
    phoneCode: 1,
  },
  {
    countryCode: 'DZ',
    phoneCode: 213,
  },
  {
    countryCode: 'EC',
    phoneCode: 593,
  },
  {
    countryCode: 'EE',
    phoneCode: 372,
  },
  {
    countryCode: 'EG',
    phoneCode: 20,
  },
  {
    countryCode: 'EH',
    phoneCode: 212,
  },
  {
    countryCode: 'ER',
    phoneCode: 291,
  },
  {
    countryCode: 'ES',
    phoneCode: 34,
  },
  {
    countryCode: 'ET',
    phoneCode: 251,
  },
  {
    countryCode: 'FI',
    phoneCode: 358,
  },
  {
    countryCode: 'FJ',
    phoneCode: 679,
  },
  {
    countryCode: 'FK',
    phoneCode: 500,
  },
  {
    countryCode: 'FM',
    phoneCode: 691,
  },
  {
    countryCode: 'FO',
    phoneCode: 298,
  },
  {
    countryCode: 'FR',
    phoneCode: 33,
  },
  {
    countryCode: 'GA',
    phoneCode: 241,
  },
  {
    countryCode: 'GB',
    phoneCode: 44,
  },
  {
    countryCode: 'GD',
    phoneCode: 1,
  },
  {
    countryCode: 'GE',
    phoneCode: 995,
  },
  {
    countryCode: 'GF',
    phoneCode: 594,
  },
  {
    countryCode: 'GG',
    phoneCode: 44,
  },
  {
    countryCode: 'GH',
    phoneCode: 233,
  },
  {
    countryCode: 'GI',
    phoneCode: 350,
  },
  {
    countryCode: 'GL',
    phoneCode: 299,
  },
  {
    countryCode: 'GM',
    phoneCode: 220,
  },
  {
    countryCode: 'GN',
    phoneCode: 224,
  },
  {
    countryCode: 'GP',
    phoneCode: 590,
  },
  {
    countryCode: 'GQ',
    phoneCode: 240,
  },
  {
    countryCode: 'GR',
    phoneCode: 30,
  },
  {
    countryCode: 'GT',
    phoneCode: 502,
  },
  {
    countryCode: 'GU',
    phoneCode: 1,
  },
  {
    countryCode: 'GW',
    phoneCode: 245,
  },
  {
    countryCode: 'GY',
    phoneCode: 592,
  },
  {
    countryCode: 'HK',
    phoneCode: 852,
  },
  {
    countryCode: 'HN',
    phoneCode: 504,
  },
  {
    countryCode: 'HR',
    phoneCode: 385,
  },
  {
    countryCode: 'HT',
    phoneCode: 509,
  },
  {
    countryCode: 'HU',
    phoneCode: 36,
  },
  {
    countryCode: 'ID',
    phoneCode: 62,
  },
  {
    countryCode: 'IE',
    phoneCode: 353,
  },
  {
    countryCode: 'IL',
    phoneCode: 972,
  },
  {
    countryCode: 'IM',
    phoneCode: 44,
  },
  {
    countryCode: 'IN',
    phoneCode: 91,
  },
  {
    countryCode: 'IO',
    phoneCode: 246,
  },
  {
    countryCode: 'IQ',
    phoneCode: 964,
  },
  {
    countryCode: 'IR',
    phoneCode: 98,
  },
  {
    countryCode: 'IS',
    phoneCode: 354,
  },
  {
    countryCode: 'IT',
    phoneCode: 39,
  },
  {
    countryCode: 'JE',
    phoneCode: 44,
  },
  {
    countryCode: 'JM',
    phoneCode: 1,
  },
  {
    countryCode: 'JO',
    phoneCode: 962,
  },
  {
    countryCode: 'JP',
    phoneCode: 81,
  },
  {
    countryCode: 'KE',
    phoneCode: 254,
  },
  {
    countryCode: 'KG',
    phoneCode: 996,
  },
  {
    countryCode: 'KH',
    phoneCode: 855,
  },
  {
    countryCode: 'KI',
    phoneCode: 686,
  },
  {
    countryCode: 'KM',
    phoneCode: 269,
  },
  {
    countryCode: 'KN',
    phoneCode: 1,
  },
  {
    countryCode: 'KP',
    phoneCode: 850,
  },
  {
    countryCode: 'KR',
    phoneCode: 82,
  },
  {
    countryCode: 'KW',
    phoneCode: 965,
  },
  {
    countryCode: 'KY',
    phoneCode: 1,
  },
  {
    countryCode: 'KZ',
    phoneCode: 7,
  },
  {
    countryCode: 'LA',
    phoneCode: 856,
  },
  {
    countryCode: 'LB',
    phoneCode: 961,
  },
  {
    countryCode: 'LC',
    phoneCode: 1,
  },
  {
    countryCode: 'LI',
    phoneCode: 423,
  },
  {
    countryCode: 'LK',
    phoneCode: 94,
  },
  {
    countryCode: 'LR',
    phoneCode: 231,
  },
  {
    countryCode: 'LS',
    phoneCode: 266,
  },
  {
    countryCode: 'LT',
    phoneCode: 370,
  },
  {
    countryCode: 'LU',
    phoneCode: 352,
  },
  {
    countryCode: 'LV',
    phoneCode: 371,
  },
  {
    countryCode: 'LY',
    phoneCode: 218,
  },
  {
    countryCode: 'MA',
    phoneCode: 212,
  },
  {
    countryCode: 'MC',
    phoneCode: 377,
  },
  {
    countryCode: 'MD',
    phoneCode: 373,
  },
  {
    countryCode: 'ME',
    phoneCode: 382,
  },
  {
    countryCode: 'MF',
    phoneCode: 590,
  },
  {
    countryCode: 'MG',
    phoneCode: 261,
  },
  {
    countryCode: 'MH',
    phoneCode: 692,
  },
  {
    countryCode: 'MK',
    phoneCode: 389,
  },
  {
    countryCode: 'ML',
    phoneCode: 223,
  },
  {
    countryCode: 'MM',
    phoneCode: 95,
  },
  {
    countryCode: 'MN',
    phoneCode: 976,
  },
  {
    countryCode: 'MO',
    phoneCode: 853,
  },
  {
    countryCode: 'MP',
    phoneCode: 1,
  },
  {
    countryCode: 'MQ',
    phoneCode: 596,
  },
  {
    countryCode: 'MR',
    phoneCode: 222,
  },
  {
    countryCode: 'MS',
    phoneCode: 1,
  },
  {
    countryCode: 'MT',
    phoneCode: 356,
  },
  {
    countryCode: 'MU',
    phoneCode: 230,
  },
  {
    countryCode: 'MV',
    phoneCode: 960,
  },
  {
    countryCode: 'MW',
    phoneCode: 265,
  },
  {
    countryCode: 'MX',
    phoneCode: 52,
  },
  {
    countryCode: 'MY',
    phoneCode: 60,
  },
  {
    countryCode: 'MZ',
    phoneCode: 258,
  },
  {
    countryCode: 'NA',
    phoneCode: 264,
  },
  {
    countryCode: 'NC',
    phoneCode: 687,
  },
  {
    countryCode: 'NE',
    phoneCode: 227,
  },
  {
    countryCode: 'NF',
    phoneCode: 672,
  },
  {
    countryCode: 'NG',
    phoneCode: 234,
  },
  {
    countryCode: 'NI',
    phoneCode: 505,
  },
  {
    countryCode: 'NL',
    phoneCode: 31,
  },
  {
    countryCode: 'NO',
    phoneCode: 47,
  },
  {
    countryCode: 'NP',
    phoneCode: 977,
  },
  {
    countryCode: 'NR',
    phoneCode: 674,
  },
  {
    countryCode: 'NU',
    phoneCode: 683,
  },
  {
    countryCode: 'NZ',
    phoneCode: 64,
  },
  {
    countryCode: 'OM',
    phoneCode: 968,
  },
  {
    countryCode: 'PA',
    phoneCode: 507,
  },
  {
    countryCode: 'PE',
    phoneCode: 51,
  },
  {
    countryCode: 'PF',
    phoneCode: 689,
  },
  {
    countryCode: 'PG',
    phoneCode: 675,
  },
  {
    countryCode: 'PH',
    phoneCode: 63,
  },
  {
    countryCode: 'PK',
    phoneCode: 92,
  },
  {
    countryCode: 'PL',
    phoneCode: 48,
  },
  {
    countryCode: 'PM',
    phoneCode: 508,
  },
  {
    countryCode: 'PR',
    phoneCode: 1,
  },
  {
    countryCode: 'PS',
    phoneCode: 970,
  },
  {
    countryCode: 'PT',
    phoneCode: 351,
  },
  {
    countryCode: 'PW',
    phoneCode: 680,
  },
  {
    countryCode: 'PY',
    phoneCode: 595,
  },
  {
    countryCode: 'QA',
    phoneCode: 974,
  },
  {
    countryCode: 'RE',
    phoneCode: 262,
  },
  {
    countryCode: 'RO',
    phoneCode: 40,
  },
  {
    countryCode: 'RS',
    phoneCode: 381,
  },
  {
    countryCode: 'RU',
    phoneCode: 7,
  },
  {
    countryCode: 'RW',
    phoneCode: 250,
  },
  {
    countryCode: 'SA',
    phoneCode: 966,
  },
  {
    countryCode: 'SB',
    phoneCode: 677,
  },
  {
    countryCode: 'SC',
    phoneCode: 248,
  },
  {
    countryCode: 'SD',
    phoneCode: 249,
  },
  {
    countryCode: 'SE',
    phoneCode: 46,
  },
  {
    countryCode: 'SG',
    phoneCode: 65,
  },
  {
    countryCode: 'SH',
    phoneCode: 290,
  },
  {
    countryCode: 'SI',
    phoneCode: 386,
  },
  {
    countryCode: 'SJ',
    phoneCode: 47,
  },
  {
    countryCode: 'SK',
    phoneCode: 421,
  },
  {
    countryCode: 'SL',
    phoneCode: 232,
  },
  {
    countryCode: 'SM',
    phoneCode: 378,
  },
  {
    countryCode: 'SN',
    phoneCode: 221,
  },
  {
    countryCode: 'SO',
    phoneCode: 252,
  },
  {
    countryCode: 'SR',
    phoneCode: 597,
  },
  {
    countryCode: 'SS',
    phoneCode: 211,
  },
  {
    countryCode: 'ST',
    phoneCode: 239,
  },
  {
    countryCode: 'SV',
    phoneCode: 503,
  },
  {
    countryCode: 'SX',
    phoneCode: 1,
  },
  {
    countryCode: 'SY',
    phoneCode: 963,
  },
  {
    countryCode: 'SZ',
    phoneCode: 268,
  },
  {
    countryCode: 'TC',
    phoneCode: 1,
  },
  {
    countryCode: 'TD',
    phoneCode: 235,
  },
  {
    countryCode: 'TG',
    phoneCode: 228,
  },
  {
    countryCode: 'TH',
    phoneCode: 66,
  },
  {
    countryCode: 'TJ',
    phoneCode: 992,
  },
  {
    countryCode: 'TK',
    phoneCode: 690,
  },
  {
    countryCode: 'TL',
    phoneCode: 670,
  },
  {
    countryCode: 'TM',
    phoneCode: 993,
  },
  {
    countryCode: 'TN',
    phoneCode: 216,
  },
  {
    countryCode: 'TO',
    phoneCode: 676,
  },
  {
    countryCode: 'TR',
    phoneCode: 90,
  },
  {
    countryCode: 'TT',
    phoneCode: 1,
  },
  {
    countryCode: 'TV',
    phoneCode: 688,
  },
  {
    countryCode: 'TW',
    phoneCode: 886,
  },
  {
    countryCode: 'TZ',
    phoneCode: 255,
  },
  {
    countryCode: 'UA',
    phoneCode: 380,
  },
  {
    countryCode: 'UG',
    phoneCode: 256,
  },
  {
    countryCode: 'US',
    phoneCode: 1,
  },
  {
    countryCode: 'UY',
    phoneCode: 598,
  },
  {
    countryCode: 'UZ',
    phoneCode: 998,
  },
  {
    countryCode: 'VA',
    phoneCode: 39,
  },
  {
    countryCode: 'VC',
    phoneCode: 1,
  },
  {
    countryCode: 'VE',
    phoneCode: 58,
  },
  {
    countryCode: 'VG',
    phoneCode: 1,
  },
  {
    countryCode: 'VI',
    phoneCode: 1,
  },
  {
    countryCode: 'VN',
    phoneCode: 84,
  },
  {
    countryCode: 'VU',
    phoneCode: 678,
  },
  {
    countryCode: 'WF',
    phoneCode: 681,
  },
  {
    countryCode: 'WS',
    phoneCode: 685,
  },
  {
    countryCode: 'XK',
    phoneCode: 383,
  },
  {
    countryCode: 'YE',
    phoneCode: 967,
  },
  {
    countryCode: 'YT',
    phoneCode: 262,
  },
  {
    countryCode: 'ZA',
    phoneCode: 27,
  },
  {
    countryCode: 'ZM',
    phoneCode: 260,
  },
  {
    countryCode: 'ZW',
    phoneCode: 263,
  },
];
